module.exports = __webpack_public_path__ + "media/hyper/images/startup-f27f82ed591e2a572177e5c3fc8f42ae.svg";